import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Container = styled.div(() =>
  mq({
    width: '100%',
    maxWidth: '840px',
    '& > div:first-of-type': {
      marginBottom: defaultTheme.spacing.l,
    },
  }),
);

export const ContentList = styled.div(() =>
  mq({
    width: '100%',
    backgroundColor: defaultTheme.background.white,
    padding: [
      `${defaultTheme.spacing.xxl} ${defaultTheme.spacing.l}`,
      `${defaultTheme.spacing.xxl} ${defaultTheme.spacing.l}`,
      `32px 64px`,
      `32px 64px`,
    ],
    '& > h2': {
      fontSize: defaultTheme.font.size.l,
      fontWeight: 'bold',
      textAlign: 'center',
      borderBottom: `1px solid ${defaultTheme.border.color.mediumLightGray}`,
      paddingBottom: defaultTheme.spacing.xxl,
    },
  }),
);

export const ButtonWrapper = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'center',
    marginTop: defaultTheme.spacing.s,
  }),
);

export const ContentEmptyMessage = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    color: defaultTheme.text.gray,
    textAlign: 'center',
    lineHeight: defaultTheme.font.height.l,
    backgroundColor: defaultTheme.background.white,
    padding: `40px 0 ${defaultTheme.spacing.l}`,
    '& > br': {
      display: ['inherit', 'inherit', 'none'],
    },
  }),
);
